import { render, staticRenderFns } from "./Orders1.vue?vue&type=template&id=07bd7d60&"
import script from "./Orders1.vue?vue&type=script&lang=js&"
export * from "./Orders1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports